import React from "react"
import RichTextConnector from "../RichText/RichTextConnector"

export const formatButton = ({ buttons, locale }) => {
  let firstButton
  let firstButtonText

  if (buttons?.length > 0) {
    firstButton = buttons[0]
  }

  if (firstButton?.url?.url?.substring(0, 4) === "http") {
    firstButton.url.external = true
  }

  if (firstButton?.text) {
    firstButtonText = firstButton.text
  }

  if (!firstButton?.text) {
    firstButtonText = firstButton?.url?.text
  }

  return {
    text: firstButtonText,
    url:
      firstButton?.url?.external === true
        ? firstButton?.url?.url
        : `/${locale}/${firstButton?.url?.url}`,
    external: firstButton?.url?.external,
  }
}

export const formatDetails = (richTextDetails, location) => {
  let details = null

  if (richTextDetails) {
    const data = {
      content: richTextDetails,
      colorScheme: "transparentDarkText",
    }
    details = <RichTextConnector data={data} location={location} />
  }

  return details
}

const parseCookieName = updatedAt => {
  return `promotion-banner-${updatedAt ? Date.parse(updatedAt) : 0}`
}

export const setBannerCookie = (cookiesApi, updatedAt, redisplayDuration) => {
  if (typeof window === "undefined") {
    return
  }

  const cookieName = parseCookieName(updatedAt)

  cookiesApi.set(cookieName, "true", {
    expires: redisplayDuration,
    path: "/",
    secure: window.location.protocol === "https:",
  })
}

export const checkBannerCookie = (cookiesApi, updatedAt) => {
  if (typeof window === "undefined") {
    return
  }
  return cookiesApi.get(parseCookieName(updatedAt))
}

export const withinDateRange = (startDate, endDate) => {
  const parsedStart = startDate ? Date.parse(startDate) : 0
  const parsedEnd = endDate ? Date.parse(endDate) : 0
  const now = Date.now()
  return now >= parsedStart && now <= parsedEnd
}

export const returnActivePromotionBanner = promotionBanner => {
  let activeBanner
  if (promotionBanner && promotionBanner?.length) {
    activeBanner = promotionBanner?.filter(banner =>
      withinDateRange(banner.startDate, banner.endDate)
    )
    activeBanner = activeBanner.sort().reverse()
  } else {
    activeBanner = null
  }
  return activeBanner
}
